import { createContext, useContext } from 'react';

import type { ChatbotInitOptions } from '@eneco/chatbot-types';

export type { ChatbotInitOptions };

export type {
  AuthTokens,
  ChatbotCallbacks,
  ChatbotState,
  ConnectionStatus,
  ConversationData,
  LoginRequiredData,
  Namespace,
  Visibility,
} from '@eneco/chatbot-types';

type MountFn = (params?: ChatbotInitOptions) => void;
export type ChatV2ContextValue = [MountFn];

export const ChatV2Context = createContext<ChatV2ContextValue | null>(null);

export function useChatV2(): ChatV2ContextValue {
  const context = useContext(ChatV2Context);
  if (!context) {
    throw new Error('useChatV2 should only be used within a <ChatProviderV2>');
  }
  return context;
}
